<template>
  <v-row>
    <v-col cols="12">
      <v-carousel width="100%">
        <v-carousel-item
          v-for="(item,i) in preRegisteredValues"
          :key="i"
          :src="source(item)"
          reverse-transition="fade-transition"
          transition="fade-transition"
        ></v-carousel-item>
      </v-carousel>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props:{
    preRegisteredValues: {
      type:Array,
      default: ()=> {return []}
    }
  },
  methods:{
    source(i){
      return process.env.VUE_APP_CF_API_URL + '/api/projects/images/' + i
    }
  }
  
}
</script>
